"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TrustpayDepositWorkflowComponent = _interopRequireDefault(require("../PaymentProcessors/TrustpayDepositWorkflowComponent"));
var _RazorPayDepositWorkflowComponent = _interopRequireDefault(require("../PaymentProcessors/RazorPayDepositWorkflowComponent"));
var _PsigateDepositWorkflowComponent = _interopRequireDefault(require("../PaymentProcessors/PsigateDepositWorkflowComponent"));
var _InterswitchDepositWorkflowComponent = _interopRequireDefault(require("../PaymentProcessors/InterswitchDepositWorkflowComponent"));
var _FennasDepositWorkflowComponent = _interopRequireDefault(require("../PaymentProcessors/FennasDepositWorkflowComponent"));
var _HyphenDepositWorkflowContainer = _interopRequireDefault(require("../PaymentProcessors/Hyphen/HyphenDepositWorkflowContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GenericPaymentWorkflowComponent = function GenericPaymentWorkflowComponent(_ref) {
  var depositInfo = _ref.depositInfo,
    templateType = _ref.templateType;
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var _ref2 = depositInfo[0] ? JSON.parse(depositInfo[0]) : {},
    PaymentAPI = _ref2.PaymentAPI,
    URL = _ref2.URL,
    RedirectURL = _ref2.RedirectURL,
    SerializedPaymentTransactionObject = _ref2.SerializedPaymentTransactionObject;
  if (templateType === 'Hyphen') {
    return /*#__PURE__*/_react["default"].createElement(_HyphenDepositWorkflowContainer["default"], null);
  }
  if (RedirectURL) {
    window.location = RedirectURL;
    return /*#__PURE__*/_react["default"].createElement("p", null, "Redirecting...");
  }
  if (PaymentAPI === 'TrustPay') {
    return /*#__PURE__*/_react["default"].createElement(_TrustpayDepositWorkflowComponent["default"], {
      url: URL
    });
  }
  if (SerializedPaymentTransactionObject) {
    var options = JSON.parse(SerializedPaymentTransactionObject);
    if (PaymentAPI === 'Razorpay') {
      return /*#__PURE__*/_react["default"].createElement(_RazorPayDepositWorkflowComponent["default"], {
        options: options
      });
    }
    if (PaymentAPI === 'Psigate') {
      return /*#__PURE__*/_react["default"].createElement(_PsigateDepositWorkflowComponent["default"], {
        options: _objectSpread(_objectSpread({}, options), {}, {
          Email: ''
        })
      });
    }
    if (PaymentAPI === 'Interswitch') {
      return /*#__PURE__*/_react["default"].createElement(_InterswitchDepositWorkflowComponent["default"], {
        options: options
      });
    }
    if (PaymentAPI === 'Fennas') {
      return /*#__PURE__*/_react["default"].createElement(_FennasDepositWorkflowComponent["default"], {
        options: options
      });
    }
  }
  if (PaymentAPI === null) {
    return /*#__PURE__*/_react["default"].createElement("p", null, t("Server provided an unexpected response."));
  }
  return null;
};
GenericPaymentWorkflowComponent.defaultProps = {
  depositInfo: []
};
GenericPaymentWorkflowComponent.propTypes = {
  depositInfo: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = GenericPaymentWorkflowComponent;